import { Injectable } from '@angular/core';
import { UserQualificationV2 } from '@wilson/interfaces';
import { BehaviorSubject, Subject } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class UserQualificationsV2ListService {
  private _bulkDeleteQualifications = new Subject<void>();
  public bulkDeleteQualifications$ =
    this._bulkDeleteQualifications.asObservable();

  private selectedUserQualificationsSubject = new BehaviorSubject<
    UserQualificationV2[]
  >([]);
  public selectedQualifications$ =
    this.selectedUserQualificationsSubject.asObservable();

  public selectedQualificationsCount$ = this.selectedQualifications$.pipe(
    startWith([]),
    map((qualifications) => ({ count: qualifications.length })),
  );

  private _bulkImportedQualifications = new Subject<void>();
  public bulkImportedQualifications$ =
    this._bulkImportedQualifications.asObservable();

  setSelectedQualifications(qualifications: UserQualificationV2[]): void {
    this.selectedUserQualificationsSubject.next(qualifications);
  }

  getSelectedQualifications(): UserQualificationV2[] {
    return this.selectedUserQualificationsSubject.getValue();
  }

  clearSelection(): void {
    this.selectedUserQualificationsSubject.next([]);
  }

  triggerBulkDeleteQualifications(): void {
    this._bulkDeleteQualifications.next();
    this.clearSelection();
  }

  triggerBulkImportedQualifications(): void {
    this._bulkImportedQualifications.next();
  }
}
